<!-- Sidebar main menu -->
<app-sidebar
  class="sidebar-wrap sidebar-overlay shadow-sm"
  [class.is-open]="ui.isMobileDrawerOpen$ | async"
></app-sidebar>
<!-- Mobile/tablet drawer backdrop: visible while the drawer is open; tap to close -->
<div
  class="sidebar-backdrop d-lg-none"
  *ngIf="ui.isMobileDrawerOpen$ | async"
  (click)="ui.toggleMobileDrawer(false)"
  aria-hidden="true"
></div>
<!-- Add pushcontent or fullmenu instead overlay , keep 'sidebar-[choice here]' -->
<!-- Sidebar main menu ends-->
<!-- <p-toast key="main"></p-toast> -->
<!-- Begin page -->
<main class="home-layout bg-dark">
  <!-- Mobile top bar — visible <lg. Renders nothing on desktop (host-level
       media query in headermenu.component.scss). -->
  <app-headermenu></app-headermenu>
  <!-- main page content -->
  <div
    [ngStyle]="
      isAiSellingPage
        ? { background: 'rgb(245,245,245)', overflow: 'hidden' }
        : {}
    "
    class="main-container container-fluid has-border-radius"
  >
    <app-global-spinner></app-global-spinner>
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
    <app-fullscreen-image-viewer></app-fullscreen-image-viewer>
  </div>

  <!-- main page content ends -->
  <!-- fluid footer at bottom of page -->
  <!--<app-footerinfo class="container-fluid d-block"></app-footerinfo>-->
  <!-- fluid footer at bottom of page ends -->
  <!-- Bottom nav — visible <lg so it covers mobile + tablet (desktop has
       the permanent sidebar). The "Mere" button is the entry point to the
       full IGNTR menu drawer below lg, replacing the old hamburger that
       used to live in the top bar. -->
  <app-navbar class="bottom-nav d-lg-none"></app-navbar>
</main>
<!-- Page ends-->
